<template>
  <button
    class="button gray circle"
    @click="toggle"
    :class="{ 'red': value }">
    <font-awesome-icon
      v-if="value"
      class="icon"
      :icon="['fas', 'heart']"
    />
    <font-awesome-icon
      v-else
      class="icon"
      :icon="['far', 'heart']" />
  </button>
</template>

<script>


export default {
  name: "LikeBtn",
  props: {
    value: {
      type: Boolean,
      required: true
    },
  },
  methods: {
    toggle() {
      this.$emit("toggle");
    }
  }
};

</script>


<style scoped>


</style>
